<sc-padding fitHeight class="send-message-dialog">
  <sc-flex vertical stretchContent fitHeight>
    <sc-sub-title>
      <sc-dictionary-label dictionaryKey="tmc-yard.ui.send-message.current-transport"></sc-dictionary-label>
    </sc-sub-title>
    <sc-content-spacer vertical [half]="true"></sc-content-spacer>
    <app-transport-info-panel [carrier]="transport?.masterdata.carrier" [driver]="transport?.name"
    [identifier]="transport?.identifyingNumberplate" [scope]="transport?.masterdata.transportScope"></app-transport-info-panel>
    <sc-content-spacer vertical></sc-content-spacer>
    <sc-sub-title>
      <sc-dictionary-label dictionaryKey="tmc-yard.ui.send-message.messages"></sc-dictionary-label>
    </sc-sub-title>
    <sc-content-spacer vertical [half]="true"></sc-content-spacer>
    <sc-flex-fitting-content vertical>
      <sc-scroll-pane>
        <div class="messages">
          @for (message of messages; track message) {
            <div class="message" [ngClass]="{ 'selected': selected === message }"
              (click)="selectMessage(message)">
              <sc-padding>
                <sc-flex >
                  <sc-icon iconClass="fa-envelope"></sc-icon>
                  <sc-content-spacer></sc-content-spacer>
                  <sc-flex-fitting-content>
                    <div class="label">{{message.name}}</div>
                  </sc-flex-fitting-content>
                </sc-flex>
              </sc-padding>
            </div>
          }
          @if (messages?.length == 0) {
            <div>
              <sc-padding>
                <sc-dictionary-label dictionaryKey="shared.tmc-table.nodata"></sc-dictionary-label>
              </sc-padding>
            </div>
          }
        </div>
      </sc-scroll-pane>
    </sc-flex-fitting-content>
    <sc-content-spacer vertical></sc-content-spacer>
    <sc-flex >
      <sc-button dictionaryKey="tmc-yard.ui.send-message.action.all-transports" [disabled]="selected == null" (click)="sendMessageAllTransports()"></sc-button>
      <sc-content-spacer></sc-content-spacer>
      <sc-button dictionaryKey="tmc-yard.ui.send-message.action.all-transports-in-yard" [disabled]="selected == null" (click)="sendMessageAllTransportsOnYard()"></sc-button>
      <sc-content-spacer grow></sc-content-spacer>
      <sc-button dictionaryKey="tmc-yard.ui.send-message.action.current-transport" primary [disabled]="selected == null || transport == null || !transportHasMessaging" (click)="sendMessageCurrentTransport()"></sc-button>
    </sc-flex>
  </sc-flex>
</sc-padding>
